import classNames from "classnames";
import { useSearchDispatch, useSearchStoreContext } from "PFApp/search/search_context";
import { useMyAccountInfo } from "PFCore/hooks/queries/account/use_my_account_info";
import { useCurrentProfile } from "PFCore/hooks/queries/profile/use_current_profile";
import { useLocation, useNavigate } from "react-router";

import { useActivitiesSync } from "./hooks/use_activities_sync";
import { useMatchesSync } from "./hooks/use_matches_sync";
import { useProfilesSync } from "./hooks/use_profiles_sync";
import {
  useRedirectIfNotPermitted,
  useSyncAvailableTemplates,
  useSyncSuggestedKeywords
} from "./hooks/use_search_setup";
import { useSearchUrlSync } from "./hooks/use_search_url_sync";
import { SearchPageExportButtons } from "./parts/search_page_export_buttons";
import { SearchPageFilters } from "./parts/search_page_filters";
import { SearchPageResults } from "./parts/search_page_results";
import { SearchPageTitle } from "./parts/search_page_title";
import { ChoosenKeywords } from "./search_box/choosen_keywords";
import { SearchBox } from "./search_box/search_box";
import css from "./search_page.module.scss";
import { SearchTabs } from "./search_tabs";
import { SmartSuggestions } from "./smart_suggestions/smart_suggestions";
import { matchesTab } from "./tabs_constants";

export const SearchPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { data: currentProfile } = useCurrentProfile();
  const { data: myAccountInfo } = useMyAccountInfo();

  const dispatch = useSearchDispatch();
  const {
    search: {
      matches,
      triggerCounter,
      term,
      tab,
      searchActivityId,
      searchActivityFetchCounter,

      choosenKeywords,

      activitiesRequestFilters,
      profilesRequestFilters,
      matchesRequestFilters,

      activitiesRequestOrder,
      profilesRequestOrder,
      matchesRequestOrder,

      matchesPending,

      availableTemplates,

      activitiesPagination,
      profilesPage,
      matchesPage,

      allActivities,

      matchTypes,
      filterTypes,
      searchActivity,
      deletedKeywords,
      collectionKind,
      prevMatchesFetch
    }
  } = useSearchStoreContext();

  const trimmedTerm = term.trim(); // avoid triggering effects on no-changes (use in the deps)

  useRedirectIfNotPermitted(currentProfile, navigate);
  useSyncAvailableTemplates(dispatch, myAccountInfo);
  useSyncSuggestedKeywords({ dispatch, trimmedTerm, tab, term, choosenKeywords, matchTypes, filterTypes });

  useActivitiesSync({
    dispatch,
    term,
    trimmedTerm,
    triggerCounter,
    tab,
    availableTemplates,
    activitiesRequestFilters,
    activitiesRequestOrder,
    activitiesPagination,
    allActivities
  });

  useProfilesSync({
    dispatch,
    term,
    trimmedTerm,
    triggerCounter,
    profilesRequestFilters,
    profilesRequestOrder,
    profilesPage
  });

  useMatchesSync({
    dispatch,
    term,
    trimmedTerm,
    triggerCounter,
    myAccountInfo,
    choosenKeywords,
    deletedKeywords,
    searchActivity,
    searchActivityId,
    searchActivityFetchCounter,
    matchesPage,
    matchesRequestFilters,
    matchesRequestOrder,
    collectionKind,
    prevMatchesFetch
  });

  useSearchUrlSync({
    navigate,
    location,
    term,
    trimmedTerm,
    tab,
    searchActivityId,
    searchActivityFetchCounter,
    matchesPending,
    choosenKeywords
  });

  const filtersAllowed = !(tab === matchesTab && matches.length === 0);

  return (
    <div className={css.root}>
      <SmartSuggestions />
      <SearchPageExportButtons />
      <div className={classNames(css.wrap, { [css.wrapWithNoTerm]: !filtersAllowed })}>
        <div className={css.content}>
          <SearchBox />
          <ChoosenKeywords />
          <SearchPageFilters />
          <SearchPageTitle />
          <SearchTabs />
          <SearchPageResults />
        </div>
      </div>
    </div>
  );
};
